export default __webpack_public_path__ + "images/d124c33609cef3546be47438d79e708e-emoji-in-pain.svg";